import { Dialog, Spinner } from '@blueprintjs/core';
import * as React from 'react';

import dialogsConfig from './dialogsConfig';
import type { DialogState, DialogErrors, EditableData } from './types';

interface Props extends DialogState {
  cancelDialog: () => void;
  finishDialog: () => void;
  setErrors: (errors: DialogErrors) => void;
  changeDialogData: (data: Partial<EditableData>) => void;
}

export default function AppDialog(props: Props) {
  let content = null;
  let config;
  let title: React.ReactNode = 'Loading';
  if (props.code) {
    if (props.readyToRender) {
      config = dialogsConfig[props.code];
      const Component = config.component;
      if (typeof config.title === 'function') {
        title = config.title(props as any);
      } else {
        title = config.title;
      }
      content = (
        <Component
          onCancel={props.cancelDialog}
          onOk={props.finishDialog}
          editableData={props.editableData!}
          readOnlyData={props.readOnlyData!}
          isInProgress={props.isInProgress}
          errors={props.errors}
          handleChange={props.changeDialogData}
          setErrors={props.setErrors}
        />
      );
    } else {
      content = <Spinner />;
    }
  }
  return (
    <Dialog
      icon={config ? config.icon : undefined}
      isOpen={Boolean(props.code)}
      onClose={props.cancelDialog}
      title={title}
      canOutsideClickClose={false}
    >
      {content}
    </Dialog>
  );
}
